<template>
    <div class="order-item" :class="{'products-visiable': showProducts}">
        <div class="order-detail">
            <router-link :to="{name: 'orders.view', params: {id: order.id}}" class="order-link">
                <div class="user-name" v-if="order.data.user">
                    {{ order.data.user.name }}
                </div>
                <div class="order-number">
                    #{{ order.data.number }} - {{ order.data.createdAt | moment('LLL') }}
                </div>
            </router-link>
            <div class="order-value">
                {{ order.data.totalPrice | money }}
            </div>
            <div class="order-products-toggle">
                <button
                    class="button is-default is-small"
                    :class="{'is-active': showProducts}"
                    @click="showProducts = !showProducts"
                >
                    {{ order.data.totalProducts }} produtos
                </button>
            </div>
            <div class="order-options">
                <change-order-status :id="order.id" :set-status="order.data.status"/>
                <b-button
                    type="is-danger"
                    size="is-small"
                    class="button-remove-order"
                    @click="removeOrder(order.id)"
                    icon-left="trash"
                />
            </div>
        </div>
        <div class="order-products" v-if="showProducts">

            <div class="order-comment" v-if="order.data.comment">
                <strong>Observações:</strong>
                {{ order.data.comment }}
            </div>

            <div class="table-container">
                <table class="table is-fullwidth is-middle is-narrow">
                    <thead>
                    <tr>
                        <th>Produto</th>
                        <th>Quantidade</th>
                        <th>Valor</th>
                        <th>Valor Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="product in order.data.products" :key="product.productId">
                        <td>
                            {{ product.name }}
                            <div class="is-small">#{{ product.code }}</div>
                        </td>
                        <td>{{ product.quantity }} {{ product.measureUnit }}</td>
                        <td>{{ product.unitPrice | money }}</td>
                        <td>{{ product.totalPrice | money }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import changeOrderStatus from "@/modules/orders/components/changeOrderStatus";
import {remove} from '../orders.actions';

export default {
    name: "OrderListItem",

    components: {changeOrderStatus},

    props: {
        order: {
            type: Object,
            required: true
        },

        setShowProducts: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showProducts: this.setShowProducts
        }
    },

    watch: {
        setShowProducts(showProducts) {
            this.showProducts = showProducts;
        }
    },

    methods: {
        removeOrder(orderId) {
            remove(orderId, () => {
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: "Pedido removido com sucesso"
                });
            });
        }
    }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all.sass";
@import "@/styles/config.sass";

.order-item {
    padding: 1rem;

    &:not(:last-child) {
        border-bottom: 1px solid $border;
    }

    &.products-visiable {
        box-shadow: 0 8px 20px rgba(0, 0, 0, .05);
        background-color: $white;
        border: 1px solid $border;
        margin-bottom: 1.5rem;

        .order-detail {
            padding-bottom: .5rem;
            margin-bottom: .5rem;
            border-bottom: 1px solid $border;
        }
    }

    .order-comment {
        padding: 1rem;
        background-color: $grey-lighter;
        margin-bottom: 1rem;
    }

    .order-detail {
        display: flex;
        align-items: center;

        .order-link {
            color: $text;
            flex: 1 auto;
            padding-right: 1rem;

            &:hover {
                color: $link;
            }

            .user-name {
                font-weight: bold;
                font-size: 1.25rem;
            }

            .order-number {
                font-size: .85rem;
                color: lighten($text, 10%);
            }
        }

        .order-value {
            padding-right: 1.5rem;
            font-size: 1.25rem;
        }

        .order-products-toggle {
            padding-right: 1rem;
        }

        .order-options {
            display: flex;
            align-items: center;

            .button-remove-order {
                margin-left: 4px;
            }
        }

        @include touch {
            flex-wrap: wrap;

            .order-link {
                flex: 1 100%;
                padding: 0 0 1rem 0;
            }
        }
    }
}

</style>